/**
 * Cross-Tab Auth Sync Types
 *
 * Type definitions for cross-tab authentication synchronization.
 */

/** Message types for cross-tab communication */
export enum CrossTabMessageType {
  SIGNED_IN = 'AUTH_SIGNED_IN',
  SIGNED_OUT = 'AUTH_SIGNED_OUT',
  TOKEN_REFRESHED = 'TOKEN_REFRESHED',
  TOKEN_REFRESH_STARTED = 'TOKEN_REFRESH_STARTED',
  TOKEN_REFRESH_FAILED = 'TOKEN_REFRESH_FAILED',
  /**
   * One tab is spending a magic-link token right now, so a sibling door
   * waiting on the same flow can stop waiting. Carries `flowId` and nothing
   * else: never the request secret, never the one-time token, never the
   * address.
   */
  MAGIC_LINK_CLAIMED = 'MAGIC_LINK_CLAIMED',
}

/** Structure of messages sent via BroadcastChannel */
export interface CrossTabMessage {
  type: CrossTabMessageType;
  tabId: string;
  timestamp: number;
  /** Present on MAGIC_LINK_CLAIMED only. An opaque, TTL-bounded flow id. */
  flowId?: string;
}

/** Options for authStateChanged() */
export interface AuthStateChangeOptions {
  /** True if user explicitly signed in/out (vs. tab loading with existing tokens) */
  isUserInitiated?: boolean;
}

/** Callback type for auth state change events */
export type AuthStateCallback = () => void;

/** Callback type for token refresh events */
export type TokenRefreshCallback = () => void;

/**
 * Callback type for a sibling tab claiming a magic-link flow. The flow id is
 * always a string: a message that does not carry one is dropped before any
 * subscriber runs.
 */
export type MagicLinkClaimedCallback = (flowId: string) => void;
